/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-03-30 17:24:27
 * @LastEditors: Json Chen
 * @LastEditTime: 2021-06-30 17:06:16
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/index.ts
 */
export { default as SalesChannelVersionContent } from './SalesChannelVersionContent/SalesChannelVersionContent';
export { default as SalesChannelVersionProducts } from './SalesChannelVersionProducts';
export { default as SalesChannelCollectionEdit } from './SalesChannelCollection/SalesChannelCollectionEdit';
export { default as SalesChannelCollectionList } from './SalesChannelCollection/SalesChannelCollectionList';
